export default __webpack_public_path__ + "static/media/animation_password.b0a015da.gif";